import actionTypes from 'SRC/modules/redux/actionTypes'

export const setSmsCodeVerified = isVerified => ({
  type: actionTypes.SET_SMS_CODE_VERIFIED,
  payload: isVerified
})
